import { useState, useEffect } from 'react'
import axios from 'axios'
import { Helmet } from 'react-helmet-async'
import { Breadcrumb, Image } from 'antd'
import { Link } from 'react-router-dom'
import Layout from '../components/Layout'

function InpatientRooms() {

    const [rooms, setRooms] = useState([])

    useEffect(() => {
        const fetchData = () => {
            axios
                .get(`${process.env.REACT_APP_API_URL}/clinicIPD`)
                .then(async response => {
                    const { code, item, message } = await response.data

                    if (code === 10) {
                        setRooms(item)
                    } else {
                        console.log(message)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        }

        fetchData()
    }, [])

    return (
        <>
            <Helmet>
                <title>ห้องพักผู้ป่วยใน | โรงพยาบาลจริยธรรมรวมแพทย์กระบี่</title>
                <meta name='description' content={`ห้องพักผู้ป่วยใน | คลินิกและศูนย์รักษา จาก โรงพยาบาลจริยธรรมรวมแพทย์กระบี่`} />
            </Helmet>

            <Layout>
                <div className='services'>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link to='/'>หน้าหลัก</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item style={{ color: '#666' }}>ห้องพักผู้ป่วยใน</Breadcrumb.Item>
                    </Breadcrumb>

                    <div className='services__content'>
                        <h1 className='border-gradient border-gradient-gold only-bottom'>ห้องพักผู้ป่วยใน</h1>

                        {
                            rooms.length > 0 ? (
                                rooms.map((item, index) => (
                                    <div key={index}>
                                        <div className='services__banner'>
                                            <Image width={'100%'} height='auto' alt='ห้องพักผู้ป่วยใน' src={item.CLINIC_IMG} preview={false} />
                                        </div>

                                        <div className='line' />
                                    </div>
                                ))
                            ): null
                        }

                        <div className='hashtag'>
                            <p>#เราจะดูแลกัน</p>
                            <p>#LikefamilyWecare</p>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default InpatientRooms
